import { render, staticRenderFns } from "./videodetails.vue?vue&type=template&id=57d5059b&scoped=true&"
import script from "./videodetails.vue?vue&type=script&lang=js&"
export * from "./videodetails.vue?vue&type=script&lang=js&"
import style0 from "./videodetails.vue?vue&type=style&index=0&id=57d5059b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5059b",
  null
  
)

export default component.exports